export default function mapPageComponents(pageContent) {
  return (
    pageContent &&
    pageContent.reduce((accu, content) => {
      const name = (content.component && content.component) || content.__typename
      return { ...accu, [name]: content.section_content || content }
    }, {})
  )
}
